import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import Event from '../../../layouts/event';

const Title = styled.h2`
  margin: 0 0 30px 0;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 2rem;
  text-transform: uppercase;
`;

const AllUpcomingEvents = () => {
  const { futureEvents } = useStaticQuery(graphql`
    query PdVAllFutureEventsQuery {
      futureEvents: allWpAgenda(
        filter: {
          status: { eq: "publish" },
          isInFuture: { eq: true }
        },
        sort: { iSO8601date: ASC }
      ) {
        edges {
          node {
            id
            ...Event
          }
        }
      }
    }
  `);

  return (
    <Container small>
      <Title>Alle komende events</Title>
      {futureEvents.edges.map(({ node }) => (
        <Event key={node.id} {...node} />
      ))}
    </Container>
  );
};

export default AllUpcomingEvents;
